/**
 * Highlight the searchValue and return the highlig
 * @param text
 * @returns
 */
const HighlightText = (searchValue: string | null, text: string): React.ReactNode => {
  if (!searchValue) return text;

  const regex = new RegExp(`(${searchValue})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part) =>
    regex.test(part) ? (
      <span key={part} className="highlight">
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export default HighlightText;
